import moment from 'moment';
import { Patient } from '../state-machine/patient-forms.types';
import { RxPatientData } from './patient-forms-services.token';
import { SavedPatientDto, SearchPatientItem } from './patient-link-api.service';

export const mapRxPatientDataToPatient = (data: RxPatientData | null): Patient | null => {
	if (!data?.UID) {
		return null;
	}

	return {
		id: data.UID,
		invisalignId: null,
		firstName: data.FirstName ?? '',
		lastName: data.LastName ?? '',
		dateOfBirth:
			data.DateOfBirth instanceof Date && !isNaN(data.DateOfBirth.getTime()) ? moment(data.DateOfBirth).format('YYYY-MM-DD') : '',
		gender: data.Gender === 0 ? 'Male' : data.Gender === 1 ? 'Female' : '',
		chartNumber: data.ChartNumber ?? '',
		system: 'iTero'
	};
};

export const mapDtoToPatient = (dto: SavedPatientDto): Patient => {
	return {
		id: dto.uid ?? dto.id?.toString() ?? null,
		invisalignId: null,
		firstName: dto.firstName ?? '',
		lastName: dto.lastName ?? '',
		dateOfBirth: dto.DateOfBirth || '',
		gender: dto.gender === 0 ? 'Male' : dto.gender === 1 ? 'Female' : '',
		chartNumber: dto.chartNumber ?? '',
		system: 'iTero'
	};
};

export const mapSearchItemToPatient = (item: SearchPatientItem): Patient => {
	const type = item.type?.toLowerCase();

	return {
		id: item.iteroPatientId ?? item.invisalignPatientId ?? null,
		invisalignId: item.invisalignPatientId ?? null,
		firstName: item.firstName ?? '',
		lastName: item.lastName ?? '',
		dateOfBirth: item.dateOfBirth ?? '',
		gender: item.gender === 0 ? 'Male' : item.gender === 1 ? 'Female' : '',
		chartNumber: item.chartNumber ?? '',
		system: type === 'linked' ? 'both' : type === 'invisalign' ? 'Invisalign' : 'iTero'
	};
};
